module.exports = __webpack_public_path__ + "static/img/zd_small.27d3b2a5.png";